import { User, UserStub } from "api/common/types/auth.types";
import { TDateISO } from "api/common/types/datetime.types";
import { valueof } from "api/common/utils/type.utils";
import { OrgStub } from "api/memberPortal/orgs/orgs.types";
import { ProductStub } from "api/memberPortal/project/product/product.types";

export const VALIDATOR_ROLES = {
  LEAD_VALIDATOR: "Lead Validator",
  SENIOR_VALIDATOR: "Senior Validator",
  ECR_TEAM: "ECR Team",
  ECR_TEAM_TRAINEE: "ECR Team(Trainee)",
  LEAD_VALIDATOR_TRAINEE: "Lead Validator(Trainee)",
  STAFF_LIAISON: "Staff Liaison",
} as const;
export type ValidatorRoles = valueof<typeof VALIDATOR_ROLES>;

export const TEAM_TYPES = {
  EVALUATION: "Evaluation",
  VALIDATION: "Validation",
} as const;
export type TeamTypes = valueof<typeof TEAM_TYPES>;

export interface ValidatorCheck {
  is_validator: boolean;
}

export interface ContractVehicle {
  desig: string;
  vehicle: string;
  veid: number;
}

// TODO: Cleanup
//  I alphabetized and slightly tweaked this one.
// theres some additional work to actually clean it up
// but its slightly better now
export interface ProjectPersonnel {
  id: number;
  approved: boolean;
  assigned_by: User;
  assigned_on: TDateISO;
  contract_vehicle: ContractVehicle;
  maintenance_id: number | null;
  non_user_member: string | null;
  pp_team_id: OrgStub;
  product_id: ProductStub;
  project_id: number | null; // looks like Project Stub
  rejected: boolean;
  reason: string;
  removed_by: User;
  removed_on: TDateISO;
  role: string; // probably some auth role
  team_type: TeamTypes; // probably
  user_id: UserStub;
}
